import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import {
    Button,
    Dialog,
    makeStyles,
    DialogContent,
} from '@material-ui/core';
import StringUtils from 'lib/StringUtils';
import ButtonStyles from 'styles/theme/Button';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import DialogAppBar from 'components/widgets/modal/DialogAppBar';

const buttonStyles = makeStyles((theme) => ButtonStyles.getStyle(theme));
const useStyles = makeStyles((theme) => ({
    AppBar: {
        color: theme.palette.text.white,
        backgroundColor: theme.palette.background.sanMarino,
        '& h4': {
            color: theme.palette.text.white,
        },
    },
    dialogContent: {
        padding: '10px 0',
    },
}));

const CatalogDialog = ({
    onSave,
    onClose,
    isEditing,
    fieldName,
    currentValue,
}) => {
    const classes = { ...useStyles(), ...buttonStyles() };
    const [name, setName] = useState('');

    useEffect(() => {
        if (!StringUtils.isEmpty(currentValue)) {
            setName(currentValue);
        }
    }, [currentValue]);

    return (
        <Dialog
            open
            fullWidth
            maxWidth="sm"
            scroll="paper"
            disableBackdropClick
            disableEscapeKeyDown
            onMouseDown={(e) => e.stopPropagation()}
        >
            <DialogAppBar
                toolbarSize="md"
                appBarClassName={classes.AppBar}
                title={`${isEditing ? 'Edit' : 'Add'} ${fieldName}`}
                onClose={() => onClose(null, null, null, false, true)}
            />
            <DialogContent>
                <div className={classes.dialogContent}>
                    <TextField
                        fullWidth
                        autoFocus
                        value={name}
                        label="Name"
                        margin="dense"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        onChange={({ target: { value } }) => setName(value)}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => onSave(name)}
                    disabled={StringUtils.isEmpty(name)}
                    className={classes.containedSecondaryInfo}
                >
                    Ok
                </Button>
                <Button
                    className={classes.containedError}
                    onClick={() => onClose(null, null, null, false, true)}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

CatalogDialog.defaultProps = {
    currentValue: '',
};

CatalogDialog.propTypes = {
    currentValue: PropTypes.string,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    isEditing: PropTypes.bool.isRequired,
    fieldName: PropTypes.string.isRequired,
};

export default CatalogDialog;
